var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_127_874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9884 20.1751L32.9879 20.1744C32.8837 20.0306 32.7529 19.9097 32.6034 19.8181C32.4539 19.7265 32.2885 19.666 32.1167 19.6397C31.9448 19.6133 31.7696 19.6216 31.6008 19.664C31.432 19.7065 31.2726 19.7824 31.1319 19.8879L31.1305 19.8889L24.8974 24.5388L24.6979 24.6877H24.449H18.1669C17.7439 24.6877 17.3402 24.5175 17.044 24.2176C16.7481 23.9181 16.5835 23.5137 16.5835 23.094C16.5835 22.6743 16.7481 22.2699 17.044 21.9703C17.3402 21.6705 17.7439 21.5003 18.1669 21.5003H22.2421C22.7567 21.5003 23.1708 21.1472 23.2401 20.7254L23.2403 20.7241C23.263 20.5879 23.256 20.4484 23.22 20.3155C23.1839 20.1825 23.1199 20.0597 23.0328 19.9556C22.9458 19.8514 22.838 19.7684 22.7173 19.7117C22.5966 19.6551 22.4656 19.6259 22.3333 19.6259H22.3332H13.9995H13.9993C12.7684 19.6257 11.5736 20.0535 10.615 20.8396C10.615 20.8396 10.6149 20.8397 10.6149 20.8397C10.6148 20.8398 10.6146 20.8399 10.6145 20.84L8.193 22.8297L7.98546 23.0003H7.71686H4.83736C4.81726 23.0007 4.7963 23.0089 4.77934 23.0261C4.76202 23.0436 4.75053 23.0691 4.75 23.0977V28.1526C4.75053 28.1811 4.76202 28.2066 4.77934 28.2242C4.7963 28.2413 4.81726 28.2496 4.83736 28.25L22.9054 28.25C22.9057 28.25 22.9059 28.25 22.9062 28.25C23.9004 28.2474 24.8692 27.9257 25.673 27.3296C25.6733 27.3293 25.6737 27.3291 25.674 27.3288L32.705 22.0798L32.9884 20.1751ZM32.9884 20.1751C33.1991 20.4653 33.2884 20.83 33.2347 21.1888C33.181 21.5472 32.9895 21.8671 32.7054 22.0796L32.9884 20.1751ZM16.4178 11.2809V10.5309H15.6678H12.3343C12.3152 10.5309 12.295 10.5233 12.2786 10.5067C12.2619 10.4898 12.2509 10.465 12.2509 10.4372V7.0623C12.2509 7.03448 12.2619 7.00964 12.2786 6.99275C12.295 6.97618 12.3152 6.96859 12.3343 6.96859H15.6678H16.4178V6.21859V2.84372C16.4178 2.8159 16.4288 2.79105 16.4455 2.77417C16.4618 2.7576 16.482 2.75 16.5012 2.75H19.8347C19.8538 2.75 19.874 2.7576 19.8904 2.77417C19.907 2.79105 19.918 2.8159 19.918 2.84372V6.21859V6.96859H20.668H24.0015C24.0206 6.96859 24.0409 6.97618 24.0572 6.99275C24.0739 7.00964 24.0849 7.03449 24.0849 7.0623V10.4372C24.0849 10.465 24.0739 10.4898 24.0572 10.5067C24.0409 10.5233 24.0206 10.5309 24.0015 10.5309H20.668H19.918V11.2809V14.6558C19.918 14.6836 19.907 14.7084 19.8904 14.7253C19.874 14.7419 19.8538 14.7495 19.8347 14.7495H16.5012C16.4821 14.7495 16.4618 14.7419 16.4455 14.7253C16.4288 14.7084 16.4178 14.6836 16.4178 14.6558V11.2809Z",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_127_874",
    x: 0,
    y: 0,
    width: 38,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_127_874"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_127_874",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.a0c8a36709b37a3e24ff557492496531.svg";
export { ForwardRef as ReactComponent };